import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const GeneratedEnergyTable = ({ component, rows }) => {
    return (
        <TableContainer component={component}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ textAlign: 'center' }}>Time</TableCell>
                        <TableCell style={{ textAlign: 'center' }} align="right">Generated Energy</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Map through the rows and create a table row for each */}
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell style={{ textAlign: 'center' }} component="th" scope="row">{row.time}</TableCell>
                            <TableCell style={{ textAlign: 'center' }} align="right">{row.generatedEnergy} W/h</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default GeneratedEnergyTable;